import React, { useState, useEffect } from 'react';
import './TermsConditions.css';
import DynamicBanner from '../../Pages/include/DynamicBanner';
import api from '../../../api';

const TermsConditions = () => {
    const [termsData, setTermsData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchTermsData = async () => {
            try {
                const response = await api.get("/api/sitepages/academic/campus-life");
                const data = response.data;

                if (data.status && data.data) {
                    const termsPage = data.data.find(page => page.page_slug === "terms");
                    
                    if (termsPage) {
                        // Clean the image URLs before setting the data
                        const cleanedTermsPage = cleanImageUrls(termsPage);
                        setTermsData(cleanedTermsPage);
                    } else {
                        throw new Error("Terms and conditions page not found");
                    }
                } else {
                    throw new Error("Invalid data structure");
                }
                
                setIsLoading(false);

            } catch (err) {
                console.error("Error fetching Terms and Conditions data:", err);
                setError("Failed to load Terms and Conditions data");
                setIsLoading(false);
            }
        };

        fetchTermsData();
    }, []);

    // FIXED: Function to strip the domain and 'public' folder from the URL
    const cleanImageUrls = (data) => {
        if (!data.banner?.images) return data;
        
        const cleanedImages = data.banner.images.map(img => {
            if (!img) return img;

            if (img.includes('/public/')) {
                const parts = img.split('/public');
                // parts[1] will be "/storage/campus_life/..."
                return parts[1];
            }

            return img;
        });

        return {
            ...data,
            banner: {
                ...data.banner,
                images: cleanedImages
            }
        };
    };

    if (isLoading) {
        return (
            <div className="termsconditions-page">
                <div className="text-center py-5">
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                    <p className="mt-2">Loading Terms and Conditions...</p>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="termsconditions-page">
                <div className="alert alert-danger text-center m-4" role="alert">
                    Error loading Terms and Conditions: {error}
                </div>
            </div>
        );
    }

    if (!termsData) {
        return (
            <div className="termsconditions-page">
                <div className="alert alert-warning text-center m-4" role="alert">
                    No Terms and Conditions data available at the moment.
                </div>
            </div>
        );
    }

    // Extract API Data
    const bannerData = termsData.banner || {};
    const contentData = termsData.content || {};

    const bannerTitle = bannerData.title || "Terms and Conditions";
    const bannerImages = bannerData.images || [];
     const mobileeImages = bannerData.mobile_images || [];
    const pageHeading = contentData.heading || "Terms and Conditions";
    const termsList = contentData.list || [];

    return (
        <div className="termsconditions-page">
            {/* Dynamic Banner */}
            {bannerImages.length > 0 && (
                <DynamicBanner
                    title={bannerTitle}
                    bgImage={bannerImages}
                    bgImageMobile={mobileeImages}
                />
            )}

            {/* Terms and Conditions Content Section */}
            <section className="termscondition">
                <div className="container">
                    <div className="row mb-5">
                        <div className="col-md-12">
                            <div className="res-content">
                                <div className="sec-title text-center">
                                    <h2>{pageHeading}</h2>
                                </div>

                                <div className="row">
                                    {termsList.length > 0 ? (
                                        <ul className="admission-list">
                                            {termsList.map((term, index) => (
                                                <li key={index}>
                                                    <i className="fa fa-check-circle-o"></i> {term}
                                                </li>
                                            ))}
                                        </ul>
                                    ) : (
                                        <div className="text-center">
                                            <p>No terms and conditions available.</p>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default TermsConditions;